//TODO: Refrefactor needed: all list views are similar, check if it can be refactored
import React, { useState } from 'react';
import NoApplications from './NoApplications';
import Applications from './Applications';
import AddApplications from './AddApplications'

function ApplicationsView({ productId, applications, history }) {
    const [showAddApplications, setShowAddApplications] = useState(false)
    return (
        <div className="supplierslist-wrapper border-1-radius">
            {applications!= undefined && applications.length > 0
                ? 
                <span>
                    <AddApplications productId={productId} history={history} />
                    <Applications applications={applications} history={history} />
                </span>
                : showAddApplications
                    ? <AddApplications productId={productId} history={history} />
                    : <NoApplications setShowAddApplications={setShowAddApplications} history={history} />
            }
        </div>
    )
}

export default ApplicationsView;